module.exports = __webpack_public_path__ + "img/american-dollar-symbol.872884f6.png";